module.exports = __webpack_public_path__ + "img/category-gemmology.6e0eab9c.svg";